import { useEffect, useState } from 'react';

import { useGetNotificationsQuery } from '@app/api/Notifications';
import { useUserPrint } from '@app/hooks';
import { useErrorHandler } from '@app/shared/hooks';

const PAGE_SIZE = 10;

export const useNotificationsListModal = (isOpen: boolean) => {
  const [page, setPage] = useState(1);

  const { activeBranchId } = useUserPrint();

  useEffect(() => {
    if (isOpen) setPage(1);
  }, [isOpen]);

  const { data, isFetching, error, isError } = useGetNotificationsQuery(
    { ActiveBranchId: activeBranchId, page, pageSize: PAGE_SIZE },
    {
      skip: !isOpen || !activeBranchId,
      // Открытие модалки — это по сути "проверить, что нового": RTK Query
      // иначе отдаст закешированный ответ с теми же page/pageSize и не
      // сходит на бэк повторно, даже если непрочитанные уже поменялись.
      refetchOnMountOrArgChange: true,
    }
  );

  useErrorHandler([{ flag: isError, error }]);

  return {
    items: data?.Items ?? [],
    totalCount: data?.Total ?? 0,
    page,
    pageSize: PAGE_SIZE,
    isFetching,
    isError,
    setPage,
  };
};
